import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Campaigns from './Campaigns';
import Create from './Create';
import Suppliers from './Suppliers';
import List from './List';
import Fill from './Fill';
import Edit from './Edit';
import Settings from '../Settings';
import './index.css';
import ErrorPage from '../Shared/ErrorPage';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission.js';
import ProtectedRoute from '../Routes/ProtectedRoute.jsx';

const Checklist = () => {
  const actions = ConstantActions();

  return (
    <div className="container p-0">
      <div className="checklist">
        <Routes>
          <Route path="*" element={<ErrorPage />} />
          {/* <Route exact path={`/campaigns`} element={<Campaigns />} />
          <Route exact path={`/suppliers/:campaignId`} element={<Suppliers />} /> */}
          {/* <Route path={`/create/:campaignId/:supplierId`} element={<Create />} /> */}
          {/* <Route exact path={`/create/:campaignId`} element={<Create />} /> */}
          {/* <Route path={`/list/:campaignId/:supplierId`} element={<List />} /> */}
          {/* <Route exact path={`/list/:campaignId`} element={<List />} />
          <Route path={`/fill/:checklistId`} element={<Fill />} />
          <Route path={`/edit/:checklistId`} element={<Edit />} />
          <Route path={`/settings/*`} element={<Settings />} /> */}
          <Route
            exact
            path={`/campaigns`}
            element={
              <ProtectedRoute
                element={<Campaigns />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/suppliers/:campaignId`}
            element={
              <ProtectedRoute
                element={<Suppliers />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/create/:campaignId/:supplierId`}
            element={
              <ProtectedRoute
                element={<Create />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/create/:campaignId`}
            element={
              <ProtectedRoute
                element={<Create />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/list/:campaignId/:supplierId`}
            element={
              <ProtectedRoute
                element={<List />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/list/:campaignId`}
            element={
              <ProtectedRoute
                element={<List />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/fill/:checklistId`}
            element={
              <ProtectedRoute
                element={<Fill />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/edit/:checklistId`}
            element={
              <ProtectedRoute
                element={<Edit />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
          <Route
            exact
            path={`/settings/*`}
            element={
              <ProtectedRoute
                element={<Settings />}
                permissionGranted={actions.userHasPermission([
                  globalpermissions?.navBar?.menuCampaignLeads,
                  globalpermissions?.navBar?.menuChecklist,
                ])}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default Checklist;
